import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';

/**
 * Title and body of the dialog both apps show before disconnecting a weather
 * service. Disconnecting deletes the stations SmartMixin imported from it,
 * with all their history (the backend cascades the provider account), so the
 * dialog says so, naming the service. Netatmo Energy imports homes, not
 * stations: pass `'homes'`.
 */
const useDisconnectServiceConfirmation = (
  provider: string,
  removes: 'stations' | 'homes' = 'stations',
) => {
  const {formatMessage} = useIntl();
  return {
    title: formatMessage(messages.addons.disconnectServiceTitle, {provider}),
    body:
      removes === 'homes'
        ? formatMessage(messages.addons.disconnectEnergyConfirmation)
        : formatMessage(messages.addons.disconnectServiceConfirmation, {
            provider,
          }),
  };
};

export default useDisconnectServiceConfirmation;
